import api from './api';
import { API_ROUTES } from '@/lib/constants';
import { createCrudService, createSubResourceGetter } from './crud.factory';
import type { Lead, Activity, Note, Task } from '@/types/table';

export const leadService = {
  ...createCrudService<Lead>(API_ROUTES.LEADS),

  convert: async (id: string, data?: Record<string, unknown>) => {
    const response = await api.post(`${API_ROUTES.LEADS}/${id}/convert`, data);
    return response.data as { success: boolean; data: { contactId: string; dealId: string } };
  },

  assign: async (id: string, assignedToId: string) => {
    const response = await api.patch(`${API_ROUTES.LEADS}/${id}/assign`, { assignedToId });
    return response.data;
  },

  bulkAssign: async (data: { ids: string[]; assignedToId: string }) => {
    await api.post(`${API_ROUTES.LEADS}/bulk-assign`, data);
  },

  bulkDelete: async (ids: string[]) => {
    await api.post(`${API_ROUTES.LEADS}/bulk-delete`, { ids });
  },

  getActivities: createSubResourceGetter<Activity>(API_ROUTES.LEADS, 'activities'),
  getNotes: createSubResourceGetter<Note>(API_ROUTES.LEADS, 'notes'),
  getTasks: createSubResourceGetter<Task>(API_ROUTES.LEADS, 'tasks'),
};
